var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277,
    height: 170,
    fill: "none",
    viewBox: "0 0 277 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BF63",
    d: "M69.605 163.463c93.307 10.407 135.675 8.733 175.834-11.032C283.31 128.019 276 110.27 276 74.771c0-19.371 0-48-30.561-52.5-.512-4.367 8.561-29-2.939-20.5l-17.698 15.534C183.813 8.448 12.596-1.482 4.296 53.68.43 79.296 1.903 88.098 0 120.548c0 22.813 28.617 36.75 69.605 42.915z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupMobile);
export default __webpack_public_path__ + "static/media/popup_mobile.f3966061c73d55be8836ce42f37163cb.svg";
export { ForwardRef as ReactComponent };